import JakAktywowac from './JakAktywowac';
import Ogolne from './Ogolne';
import { PakietDlaKota, PakietDlaPsa } from './OfertaPakietu';
import Placowki from './Placowki';

const pageComponents = {
  JakAktywowac,
  Ogolne,
  PakietDlaKota,
  PakietDlaPsa,
  Placowki
};

export default pageComponents;
